/*!
 * nextsky-a11y-media.js — Trợ năng cho media tự phát + slide dạng link
 * Nextsky Ecom · 2026-09-12
 *
 * Xử lý:
 *  M1 · WCAG 2.2.2 Pause, Stop, Hide (mức A) — video tự phát và carousel tự chạy
 *       không có cách dừng. Cũng là yêu cầu bắt buộc của Shopify Theme Store:
 *       "nội dung tự chạy phải dừng hoặc tạm dừng được", "phím Space phải play/pause".
 *  M2 · WCAG 2.3.3 / 2.2.2 — không tự phát khi người dùng bật "giảm chuyển động".
 *  M3 · WCAG 4.1.2 — Swiper gán role="group" cho mọi .swiper-slide; khi slide được
 *       dựng bằng thẻ <a> thì tổ hợp đó là ARIA không hợp lệ (axe: aria-allowed-role).
 *  M4 · (tuỳ chọn) khoá slide ngoài khung nhìn khỏi tab order cho các carousel mà
 *       bản vá sẵn có trên site chưa bám được.
 *
 * Nút chèn vào 44x44 px — đạt luôn ngưỡng vùng bấm của Shopify.
 */
(function () {
  "use strict";

  var CFG = {
    chenNutDungMedia: true,      // M1
    tonTrongGiamChuyenDong: true,// M2
    suaRoleSlideLink: true,      // M3
    phuCarouselChuaVa: false,    // M4 — bật cho elagia, tắt cho Purity (Purity đã có helper riêng)
    nhan: "Play/pause",          // ghi đè bằng chuỗi đã dịch của theme
    viTri: "bottom-right",
    boQua: ".modal, .drawer",
    debug: false
  };
  if (window.NS_A11Y_MEDIA_CONFIG) {
    for (var k in window.NS_A11Y_MEDIA_CONFIG) {
      if (Object.prototype.hasOwnProperty.call(window.NS_A11Y_MEDIA_CONFIG, k)) {
        CFG[k] = window.NS_A11Y_MEDIA_CONFIG[k];
      }
    }
  }

  var ICON_PLAY =
    '<svg width="10" height="14" viewBox="0 0 10 14" fill="none" class="icon icon-play" aria-hidden="true" focusable="false">' +
    '<path d="M9.6 6.2 1.54.19A1 1 0 0 0 0 1v12a1 1 0 0 0 1.54.81l8.06-6a1 1 0 0 0 0-1.61Z" fill="currentColor"/></svg>';
  var ICON_PAUSE =
    '<svg width="10" height="14" viewBox="0 0 10 14" fill="none" class="icon icon-pause" aria-hidden="true" focusable="false">' +
    '<rect width="2" height="14" fill="currentColor" rx="1"/><rect width="2" height="14" x="8" fill="currentColor" rx="1"/></svg>';

  var giamChuyenDong = false;
  try {
    giamChuyenDong =
      CFG.tonTrongGiamChuyenDong &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {}

  function log() {
    if (CFG.debug && window.console) console.log.apply(console, ["[ns-media]"].concat([].slice.call(arguments)));
  }

  /* ---------------------------------------------------------------- */
  /* CSS                                                              */
  /* ---------------------------------------------------------------- */
  function chenCss() {
    if (document.getElementById("ns-a11y-media-style")) return;
    var c =
      ".ns-media-toggle{position:absolute;z-index:5;width:44px;height:44px;" +
      "display:inline-flex;align-items:center;justify-content:center;" +
      "border:0;border-radius:50%;cursor:pointer;padding:0;" +
      "background:rgba(0,0,0,.55);color:#fff;opacity:.7;" +
      "transition:opacity .2s ease,transform .2s ease;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}" +
      ".ns-media-toggle:hover{opacity:1;transform:scale(1.06)}" +
      ".ns-media-toggle:focus-visible{opacity:1;outline:2px solid #fff;outline-offset:2px;" +
      "box-shadow:0 0 0 4px rgba(0,0,0,.55)}" +
      ".ns-media-toggle[data-pos='bottom-right']{inset-inline-end:12px;bottom:12px}" +
      ".ns-media-toggle[data-pos='bottom-left']{inset-inline-start:12px;bottom:12px}" +
      ".ns-media-toggle .icon-play{display:none}" +
      ".ns-media-toggle[aria-pressed='true'] .icon-play{display:inline-block}" +
      ".ns-media-toggle[aria-pressed='true'] .icon-pause{display:none}" +
      "@media (prefers-reduced-motion:reduce){.ns-media-toggle{transition:none}" +
      ".ns-media-toggle:hover{transform:none}}";
    var s = document.createElement("style");
    s.id = "ns-a11y-media-style";
    s.textContent = c;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---------------------------------------------------------------- */
  /* M3 — gỡ role không hợp lệ trên slide dạng link                    */
  /* ---------------------------------------------------------------- */
  /* Link co nguon ten nao khac ngoai aria-label cua Swiper khong? */
  function coTenKhac(el) {
    if ((el.textContent || "").trim()) return true;
    if (el.hasAttribute("title") && el.getAttribute("title").trim()) return true;
    if (el.hasAttribute("aria-labelledby")) return true;
    var imgs = [].slice.call(el.querySelectorAll("img"));
    for (var i = 0; i < imgs.length; i++) {
      if ((imgs[i].getAttribute("alt") || "").trim()) return true;
    }
    return false;
  }

  function suaRoleSlide(goc) {
    if (!CFG.suaRoleSlideLink) return 0;
    var n = 0;
    var ds = (goc || document).querySelectorAll(
      '.swiper-slide[role="group"], .swiper-slide[role="listitem"]'
    );
    [].slice.call(ds).forEach(function (sl) {
      /* Chỉ gỡ khi bản thân slide đã là phần tử tương tác — lúc đó role của
         Swiper đè lên vai trò thật của thẻ và tạo ARIA không hợp lệ.
         Slide là <div> thì giữ nguyên role, vì nó có ích cho trình đọc. */
      if (sl.matches("a[href], button, [role='link'], input, select, textarea")) {
        sl.removeAttribute("role");
        /* Swiper cũng gán aria-label kiểu "3 / 8". Trên một thẻ link, nhãn đó đè
           mất tên thật nên nên bỏ — NHƯNG chỉ khi link còn nguồn tên khác.
           Slide chỉ chứa video, không ảnh không chữ, mà bị gỡ nhãn thì thành
           link không tên: đó là lỗi nặng hơn (axe: link-name). */
        var lb = sl.getAttribute("aria-label");
        if (lb && /^\s*\d+\s*\/\s*\d+\s*$/.test(lb) && coTenKhac(sl)) {
          sl.removeAttribute("aria-label");
        }
        sl.setAttribute("data-ns-role-fixed", "1");
        n++;
      }
    });
    return n;
  }

  /* ---------------------------------------------------------------- */
  /* M1 — nút tạm dừng cho media tự phát                               */
  /* ---------------------------------------------------------------- */

  function daCoDieuKhien(host) {
    /* Theme đã có sẵn nút play/pause ở một số section — không chèn chồng lên */
    return !!host.querySelector(
      ".play-button, .ns-media-toggle, video[controls], .video_control"
    );
  }

  function timHost(el) {
    var h =
      el.closest(".shopify-section") ||
      el.closest("section") ||
      el.parentElement ||
      document.body;
    /* Nut khong duoc nam trong vung [inert], neu khong chinh no cung bi vo hieu */
    var canh = 0;
    while (h && h !== document.body && h.closest("[inert]") && canh++ < 12) {
      h = h.parentElement;
    }
    return h || document.body;
  }

  /* Chi bo qua media THUC SU khong hien — khong dua vao aria-hidden.
     Video trang tri thuong duoc danh dau aria-hidden="true" mot cach dung dan,
     nhung no van dang chay truoc mat nguoi dung nen van can nut tam dung. */
  function hienThi(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 && r.height < 2) return false;
    var cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden") return false;
    return true;
  }

  function neoViTri(host) {
    /* Nút dùng position:absolute nên host phải là khối định vị */
    var cs = getComputedStyle(host);
    if (cs.position === "static") host.style.position = "relative";
  }

  var nhomDaXuLy = new WeakSet();

  function quetMedia() {
    if (!CFG.chenNutDungMedia) return;

    var nhom = new Map();

    /* video tự phát */
    [].slice.call(document.querySelectorAll("video")).forEach(function (v) {
      if (!v.autoplay && !v.hasAttribute("autoplay")) return;
      if (v.controls) return;
      if (CFG.boQua && v.closest(CFG.boQua)) return;
      if (!hienThi(v)) return;
      var h = timHost(v);
      if (!nhom.has(h)) nhom.set(h, { videos: [], swipers: [] });
      nhom.get(h).videos.push(v);
    });

    /* carousel tự chạy — chỉ tính khi có nhiều hơn 1 slide, vì 1 slide thì
       không có chuyển động nào để dừng */
    [].slice.call(document.querySelectorAll(".swiper")).forEach(function (el) {
      var sw = el.swiper;
      if (!sw || !sw.params || !sw.params.autoplay || !sw.params.autoplay.enabled) return;
      if (el.querySelectorAll(".swiper-slide").length < 2) return;
      if (CFG.boQua && el.closest(CFG.boQua)) return;
      var h = timHost(el);
      if (!nhom.has(h)) nhom.set(h, { videos: [], swipers: [] });
      nhom.get(h).swipers.push(sw);
    });

    nhom.forEach(function (data, host) {
      if (nhomDaXuLy.has(host)) return;
      if (daCoDieuKhien(host)) {
        /* Section đã có nút của theme. Vẫn phải tôn trọng giảm chuyển động. */
        if (giamChuyenDong) dungHet(data);
        nhomDaXuLy.add(host);
        return;
      }
      nhomDaXuLy.add(host);
      taoNut(host, data);
    });
  }

  function dungHet(d) {
    d.videos.forEach(function (v) {
      try { v.pause(); v.removeAttribute("autoplay"); } catch (e) {}
    });
    d.swipers.forEach(function (s) {
      try { if (s.autoplay && s.autoplay.running) s.autoplay.stop(); } catch (e) {}
    });
  }

  function chayHet(d) {
    d.videos.forEach(function (v) {
      try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
    });
    d.swipers.forEach(function (s) {
      try { if (s.autoplay && !s.autoplay.running) s.autoplay.start(); } catch (e) {}
    });
  }

  function taoNut(host, data) {
    neoViTri(host);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ns-media-toggle";
    btn.setAttribute("data-pos", CFG.viTri);
    btn.setAttribute("aria-label", CFG.nhan);
    btn.innerHTML = ICON_PAUSE + ICON_PLAY;

    /* aria-pressed = true nghĩa là "đang ở trạng thái tạm dừng" */
    var dangDung = false;

    function datTrangThai(dung) {
      dangDung = dung;
      btn.setAttribute("aria-pressed", dung ? "true" : "false");
      if (dung) dungHet(data); else chayHet(data);
    }

    btn.addEventListener("click", function () { datTrangThai(!dangDung); });

    host.appendChild(btn);

    if (giamChuyenDong) {
      datTrangThai(true);          /* người dùng đã yêu cầu giảm chuyển động */
    } else {
      btn.setAttribute("aria-pressed", "false");
    }
    log("chen nut vao", host, data.videos.length + " video, " + data.swipers.length + " carousel");
  }

  /* ---------------------------------------------------------------- */
  /* M4 — khoá slide ngoài khung (chỉ bật khi site chưa có bản vá)     */
  /* ---------------------------------------------------------------- */
  var COINERT = typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;

  function khoaSlideNgoaiKhung() {
    if (!CFG.phuCarouselChuaVa || !COINERT) return;
    [].slice.call(document.querySelectorAll(".swiper")).forEach(function (el) {
      /* Bỏ qua carousel mà bản vá sẵn có của site đã nhận */
      if (el.hasAttribute("data-a11y-region")) return;
      if (!el.swiper) return;
      var slides = [].slice.call(el.querySelectorAll(".swiper-slide"));
      if (slides.length < 2) return;
      var cr = el.getBoundingClientRect();
      if (cr.width < 1) return;
      var active = document.activeElement;
      var coAiHien = false;
      var cd = slides.map(function (s) {
        var r = s.getBoundingClientRect();
        var hien = r.width > 0 && r.right > cr.left + 1 && r.left < cr.right - 1;
        if (hien) coAiHien = true;
        return hien;
      });
      if (!coAiHien) return;                 /* đo sai thì không đụng gì */
      slides.forEach(function (s, i) {
        if (cd[i] || (active && s.contains(active))) s.removeAttribute("inert");
        else if (!s.hasAttribute("inert")) s.setAttribute("inert", "");
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Khởi động                                                        */
  /* ---------------------------------------------------------------- */
  var hen = null, henDuPhong = null;

  function chayNgay() {
    hen = null;
    if (henDuPhong) { clearTimeout(henDuPhong); henDuPhong = null; }
    suaRoleSlide(document);
    quetMedia();
    khoaSlideNgoaiKhung();
  }

  function lenLich() {
    if (hen || henDuPhong) return;
    hen = requestAnimationFrame(chayNgay);
    /* Tab chay nen thi requestAnimationFrame bi treo vo thoi han. Khong duoc
       de toan bo cong viec phu thuoc vao no — sau 400ms thi tu chay thang. */
    henDuPhong = setTimeout(function () {
      henDuPhong = null;
      if (hen) { cancelAnimationFrame(hen); hen = null; }
      chayNgay();
    }, 400);
  }

  function boot() {
    chenCss();
    lenLich();

    var lan = 0;
    var t = setInterval(function () {
      lenLich();
      if (++lan > 40) clearInterval(t);      /* ~20 giây rồi dừng */
    }, 500);

    if (window.MutationObserver) {
      new MutationObserver(lenLich).observe(document.documentElement, {
        childList: true, subtree: true
      });
    }
    window.addEventListener("resize", lenLich);
    document.addEventListener("shopify:section:load", lenLich);
    document.addEventListener("shopify:section:reorder", lenLich);
    /* Slide chạy thì vị trí đổi -> tính lại phần khoá tab order */
    document.addEventListener("focusin", lenLich, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.NSA11yMedia = {
    quetLai: lenLich,
    giamChuyenDong: giamChuyenDong,
    config: CFG,
    soNutDaChen: function () { return document.querySelectorAll(".ns-media-toggle").length; },
    soSlideDaSuaRole: function () { return document.querySelectorAll("[data-ns-role-fixed]").length; }
  };
})();
